import { render, staticRenderFns } from "./TruckZip3Overrides.vue?vue&type=template&id=e23d632a"
import script from "./TruckZip3Overrides.vue?vue&type=script&lang=ts"
export * from "./TruckZip3Overrides.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports